(ns frontend.view.user-management.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(def state (r/cursor db/app-state [:views :user-management]))
